"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The SshKnownHost model module.
 * @module model/SshKnownHost
 * @version 0.4.1
 */
var SshKnownHost = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SshKnownHost</code>.
   * SSH Known Host
   * @alias module:model/SshKnownHost
   */
  function SshKnownHost() {
    _classCallCheck(this, SshKnownHost);

    SshKnownHost.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(SshKnownHost, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>SshKnownHost</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SshKnownHost} obj Optional instance to populate.
     * @return {module:model/SshKnownHost} The populated <code>SshKnownHost</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SshKnownHost();

        if (data.hasOwnProperty('Comment')) {
          obj['Comment'] = _ApiClient.default.convertToType(data['Comment'], 'String');
        }

        if (data.hasOwnProperty('Err')) {
          obj['Err'] = _ApiClient.default.convertToType(data['Err'], 'String');
        }

        if (data.hasOwnProperty('FingerprintLegacyMD5')) {
          obj['FingerprintLegacyMD5'] = _ApiClient.default.convertToType(data['FingerprintLegacyMD5'], 'String');
        }

        if (data.hasOwnProperty('FingerprintSHA256')) {
          obj['FingerprintSHA256'] = _ApiClient.default.convertToType(data['FingerprintSHA256'], 'String');
        }

        if (data.hasOwnProperty('Hosts')) {
          obj['Hosts'] = _ApiClient.default.convertToType(data['Hosts'], ['String']);
        }

        if (data.hasOwnProperty('Marker')) {
          obj['Marker'] = _ApiClient.default.convertToType(data['Marker'], 'String');
        }

        if (data.hasOwnProperty('Raw')) {
          obj['Raw'] = _ApiClient.default.convertToType(data['Raw'], 'String');
        }

        if (data.hasOwnProperty('Rest')) {
          obj['Rest'] = _ApiClient.default.convertToType(data['Rest'], 'String');
        }

        if (data.hasOwnProperty('SshAuthorizedKey')) {
          obj['SshAuthorizedKey'] = _ApiClient.default.convertToType(data['SshAuthorizedKey'], 'String');
        }
      }

      return obj;
    }
  }]);

  return SshKnownHost;
}();
/**
 * 从公钥之中解析出来的公钥之中的 comment
 * @member {String} Comment
 */


SshKnownHost.prototype['Comment'] = undefined;
/**
 * 解析 SSH Known Host 原文(Raw)的出错信息
 * @member {String} Err
 */

SshKnownHost.prototype['Err'] = undefined;
/**
 * MD5 格式编码的主机指纹
 * @member {String} FingerprintLegacyMD5
 */

SshKnownHost.prototype['FingerprintLegacyMD5'] = undefined;
/**
 * SHA256 格式编码的主机指纹
 * @member {String} FingerprintSHA256
 */

SshKnownHost.prototype['FingerprintSHA256'] = undefined;
/**
 * 一条公钥记录可能包含多个主机名, 典型的如主机名(DNS 域名)和地址(IP)不一致, 这时候就会记录两个 host 到 Hosts 中
 * @member {Array.<String>} Hosts
 */

SshKnownHost.prototype['Hosts'] = undefined;
/**
 * 解析出来的 marker
 * @member {String} Marker
 */

SshKnownHost.prototype['Marker'] = undefined;
/**
 * SSH Known Host 原文, known_hosts 文件中的一行
 * @member {String} Raw
 */

SshKnownHost.prototype['Raw'] = undefined;
/**
 * 解析 SSH Known Host 原文(Raw) 所有规范数据剩余的数据, 一般是多余数据或额外的记录
 * @member {String} Rest
 */

SshKnownHost.prototype['Rest'] = undefined;
/**
 * 从公钥计算得到 Authorized key, 内容原文也在 Raw 中
 * @member {String} SshAuthorizedKey
 */

SshKnownHost.prototype['SshAuthorizedKey'] = undefined;
var _default = SshKnownHost;
exports.default = _default;